module.exports = __webpack_public_path__ + "static/media/FEDERALBNK.67dd7480.txt";